//  PLATFORM ADMIN
// Il platform admin è gestito tramite il nodo platformAdmins/{uid}: true nel
// Realtime Database (non più via email hardcoded). Email corrente: noleggio@admin.it.
// Per aggiungere/cambiare il platform admin: usa scripts/set-platform-admin.js
// e aggiorna la costante PLATFORM_ADMIN_EMAIL in App.js e in functions/index.js.

// Tipi di veicolo
export const VEHICLE_TYPES = [
  { value: 'auto', label: 'Auto' },
  { value: 'moto', label: 'Moto' },
];

// Categorie auto
export const CAR_CATEGORIES = ['economy', 'compact', 'suv', 'luxury', 'sport'];

// Categorie moto
export const MOTO_CATEGORIES = ['scooter', 'moto', 'vespa'];

// Giorni della settimana
export const GIORNI_SETTIMANA = [
  'Lunedì', 
  'Martedì', 
  'Mercoledì', 
  'Giovedì', 
  'Venerdì', 
  'Sabato', 
  'Domenica'
];

// ─── STATI PRENOTAZIONE ────────────────────────────────────────────────────────
// 5 stati totali:
// in_attesa_ritiro  → giallo   — prenotazione confermata, in attesa che il cliente ritiri
// auto_ritirata     → verde    — admin ha confermato il ritiro, auto in uso
// auto_in_riconsegna→ arancione— oggi è il giorno di riconsegna, in attesa restituzione
// auto_riconsegnata → viola    — admin ha confermato la riconsegna (finale positivo)
// prenotazione_annullata → rosso — annullata dall'admin (finale negativo)

export const BOOKING_STATUS = {
  CONFERMATA:           'prenotazione_confermata',
  IN_ATTESA_RITIRO:     'in_attesa_ritiro',
  AUTO_RITIRATA:        'auto_ritirata',
  AUTO_IN_RICONSEGNA:   'auto_in_riconsegna',
  AUTO_RICONSEGNATA:    'auto_riconsegnata',
  ANNULLATA:            'prenotazione_annullata',
};

// Stati che bloccano le date nel calendario (impediscono nuove prenotazioni)
// Audit 2026-09-20, punto #6: re-esportata da shared/bookingRules.js (fonte
// unica condivisa anche con functions/index.js), non più definita qui a mano.
export { STATI_BLOCCANTI } from '../utils/bookingRules.generated';

// Stati che permettono la stampa del contratto
export const STATI_STAMPA_CONTRATTO = [
  'prenotazione_confermata',
  'in_attesa_ritiro',
  'auto_ritirata',
  'auto_in_riconsegna',
  'auto_riconsegnata',
];

// Nomi mesi
export const MONTH_NAMES = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
];

// Nomi giorni abbreviati (settimana inizia da Lunedì, come in Italia)
export const DAY_NAMES = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
